import { ReactNode } from 'react';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { PageLoading } from '@/components/molecules/loading/page';
import { StyledBox } from './styles';
import { Sidebar } from '../sidebar';
import { useAuth } from '@/hooks/useAuth';
import { Navbar } from '../navbar';

type TemplateProps = {
  children: ReactNode;
};

export const Template = ({ children }: TemplateProps) => {
  const theme = useTheme();

  const { loading } = useAuth();

  const isMobileVersion = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      {loading ? (
        <>
          <PageLoading pageLoading={loading} />
          {isMobileVersion ? <Navbar /> : <Sidebar />}
        </>
      ) : (
        <>
          <StyledBox>
            {isMobileVersion && <Navbar />}
            {!isMobileVersion && <Sidebar />}
            <>{children}</>
          </StyledBox>
        </>
      )}
    </>
  );
};
